var spacingUnit = 4;
function getSpacing(multiple) {
  return multiple && "".concat(spacingUnit * multiple, "px");
}
var spacing1x = getSpacing(1);
var spacing2x = getSpacing(2);
var spacing3x = getSpacing(3);
var spacing4x = getSpacing(4);
var spacing5x = getSpacing(5);
var spacing6x = getSpacing(6);
var spacing7x = getSpacing(7);
var spacing8x = getSpacing(8);

export { getSpacing, spacing1x, spacing2x, spacing3x, spacing4x, spacing5x, spacing6x, spacing7x, spacing8x };
